import { ArticleParagraph2 } from '@cian/ui-kit';
import { TColors } from '@cian/ui-kit-design-tokens/colors';
import { forwardRef, useMemo } from 'react';

import styles from './Description.css';

interface IDescriptionProps {
  color?: TColors;
  text: string;
  lines?: number;
}

export const CSS_LINE_HEIGHT = 20;

export const Description = forwardRef<HTMLDivElement, IDescriptionProps>(function Description(
  { text, lines, color },
  ref,
) {
  const inlineStyles = useMemo(
    () =>
      lines
        ? {
            maxHeight: lines * CSS_LINE_HEIGHT,
            WebkitLineClamp: lines,
          }
        : {},
    [lines],
  );

  return (
    <div className={styles['description']} style={inlineStyles} ref={ref}>
      <ArticleParagraph2 color={color}>{text}</ArticleParagraph2>
    </div>
  );
});
